import { AdvisorInvitation } from '../../models/Advisor';
import { InvestmentEntity } from '../../models/InvestmentEntity';

export function transformAdvisorInvitation(invitation: AdvisorInvitation): AdvisorInvitation {
  const investmentEntities =
    (invitation as { entities?: InvestmentEntity[] }).entities || invitation.investmentEntities;
  let firstName = invitation.firstName || '';
  let lastName = invitation.lastName || '';
  if (!firstName && !lastName && invitation.advisorName) {
    const nameParts = invitation.advisorName.trim().split(/\s+/);
    firstName = nameParts[0] || '';
    lastName = nameParts.slice(1).join(' ') || '';
  }
  return {
    ...invitation,
    firstName,
    lastName,
    email: invitation.email || '',
    investmentEntities: investmentEntities || [],
  };
}

export function parseAdvisorInvitationsFromResponse(data: unknown): AdvisorInvitation[] {
  const responsePayload =
    data && typeof data === 'object' && 'data' in data
      ? (data as { data: AdvisorInvitation[] }).data
      : (data as AdvisorInvitation[]);
  const invitations = Array.isArray(responsePayload) ? responsePayload : [];
  return invitations.map(transformAdvisorInvitation);
}
